import { Step } from 'shared/InstallationDialog';
import { renderTranslations, spawn } from 'utils/translations';
import { ExternalLink } from '../../ExternalLink';
import { ENABLE_QODO_TRANSLATION_KEY } from '../consts';
import { useGithubInstallation } from '../githubInstallationContext';
import { getInstallationsUrlFromOrganizationUrl } from '../utils';

export const EnableQodo = () => {
  const { organizationUrl, installationId } = useGithubInstallation();

  const spawnEnableQodo = spawn(ENABLE_QODO_TRANSLATION_KEY);
  const installationsUrl = getInstallationsUrlFromOrganizationUrl(
    organizationUrl,
    installationId,
  );

  return (
    <Step
      title={spawnEnableQodo('title')}
      description={renderTranslations(
        `${ENABLE_QODO_TRANSLATION_KEY}.description`,
      )}
      className="gap-8"
    >
      <div className="text-sm text-text-general-neutral-mild">
        {spawnEnableQodo('info-message')}{' '}
        <ExternalLink
          url={installationsUrl}
          iconClassName="stroke-icon-interactive-neutral-idle group-hover:stroke-icon-interactive-neutral-hover"
        >
          {spawnEnableQodo('info-message-link')}
        </ExternalLink>
      </div>
    </Step>
  );
};
